
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { MaterialType } from "@/types/materialType";

interface EditMaterialTypeDialogProps {
  material: MaterialType | null;
  onClose: () => void;
  onSave: () => void;
  onChange: (material: MaterialType) => void;
}

export function EditMaterialTypeDialog({
  material,
  onClose,
  onSave,
  onChange,
}: EditMaterialTypeDialogProps) {
  if (!material) return null;

  return (
    <Dialog open={!!material} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Editar Tipo de Material</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="prefix">Prefixo</Label>
            <Input
              id="prefix"
              value={material.prefix}
              onChange={(e) =>
                onChange({
                  ...material,
                  prefix: e.target.value.toUpperCase(),
                })
              }
              maxLength={3}
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="material_type">Tipo de Material</Label>
            <Input
              id="material_type"
              value={material.material_type}
              onChange={(e) =>
                onChange({
                  ...material,
                  material_type: e.target.value,
                })
              }
            />
          </div>

          <div className="flex justify-end space-x-2">
            <Button variant="outline" onClick={onClose}>
              Cancelar
            </Button>
            <Button onClick={onSave}>Salvar</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
